import React, { ComponentType, createElement, lazy, ReactNode } from 'react';
import SSLIcon from 'pages/Checkout/pages/Checkout/components/SSLIcon';
import { getUrlParams } from 'utils/urlParams';

import { retry } from 'utils/retry';
import routePaths from '../constants/route';
import QuestionIcon from '../components/Icons/QuestionIcon';
import history from './history';

import RaffleTabs from '../pages/Raffle/pages/RaffleTabs';
import RafflePageTopBarIconGroup from '../pages/Raffle/components/RafflePageTopBarIconGroup';

const MobileTopup = lazy(() => retry(() => import('pages/MobileTopup')));
const WalletGiftCode = lazy(() =>
  retry(() => import('pages/WalletGiftCode/pages/WalletGiftCode'))
);
const Success = lazy(() => retry(() => import('pages/Checkout/pages/Success')));
const OrderContracts = lazy(() =>
  retry(() => import('pages/public/OrderContracts'))
);
const Address = lazy(() => retry(() => import('pages/Checkout/pages/Address')));
const Orders = lazy(() => retry(() => import('pages/Orders')));
const Landing = lazy(() => retry(() => import('pages/Landing')));
const WalletGiftCodeFaq = lazy(() =>
  retry(() => import('pages/WalletGiftCode/pages/WalletGiftCodeFaq'))
);
const MobileTopupFAQ = lazy(() =>
  retry(() => import('pages/MobileTopup/pages/MobileTopupFaq'))
);
const RaffleCart = lazy(() =>
  retry(() => import('pages/Raffle/pages/RaffleCart'))
);

const RaffleFaq = lazy(() =>
  retry(() => import('pages/Raffle/pages/RaffleFaq'))
);

const Checkout = lazy(() =>
  retry(() => import('pages/Checkout/pages/Checkout/Checkout'))
);

type TRoutePaths =
  | 'landing'
  | 'mobileTopup'
  | 'trendyolGiftCode'
  | 'checkout'
  | 'orderContracts'
  | 'success'
  | 'address'
  | 'orders'
  | 'notFound'
  | 'raffle'
  | 'raffleCart'
  | 'raffleFaq'
  | string;
export type TRoutes = Record<
  TRoutePaths,
  {
    path: string | string[];
    key: string;
    title?: string;
    exact?: boolean;
    isRootPage?: boolean;
    component: ComponentType;
    options: {
      headerTitle?: ReactNode;
      headerRight?: ReactNode;
      changeTitle?: boolean;
    };
  }
>;

export const routes: TRoutes = {
  landing: {
    key: 'landing',
    path: ['/', routePaths.landing],
    title: 'Trendyol Dijital Servisler',
    exact: true,
    isRootPage: true,
    component: Landing,
    options: {
      headerTitle: 'Trendyol Dijital Servisler',
    },
  },
  mobileTopup: {
    key: 'mobileTopup',
    path: [routePaths.mobilePackage, routePaths.mobileTL],
    title: 'Online TL / Paket Yükle',
    exact: true,
    isRootPage: false,
    component: MobileTopup,
    options: {
      headerRight: createElement(QuestionIcon, {
        onClick: () => {
          const path =
            window.location.pathname.split('/')[1] || getUrlParams().get('tab');
          history.push(`/${path}/faq`);
        },
      }),
    },
  },
  raffle: {
    key: 'raffle',
    path: [
      routePaths.raffles,
      routePaths.raffleTickets,
      routePaths.raffleResults,
      routePaths.raffleWinnings,
    ],
    title: 'Şanslı Çekiliş',
    exact: true,
    isRootPage: false,
    component: RaffleTabs,
    options: {
      headerRight: <RafflePageTopBarIconGroup />,
    },
  },
  raffleCart: {
    key: 'raffleCart',
    path: routePaths.raffleCart,
    component: RaffleCart,
    exact: true,
    isRootPage: false,
    title: 'Sepetim',
    options: {},
  },
  mobileTopupFaq: {
    key: 'mobileTopupFaq',
    path: [routePaths.mobileTLFaq, routePaths.mobilePackageFaq],
    title: 'Sıkça Sorulan Sorular',
    exact: true,
    isRootPage: false,
    component: MobileTopupFAQ,
    options: {},
  },
  raffleFaq: {
    key: 'raffleFaq',
    path: ['/raffles/faq', routePaths.raffleFaq],
    title: 'Sıkça Sorulan Sorular',
    component: RaffleFaq,
    options: {},
  },
  address: {
    key: 'address',
    path: routePaths.address,
    title: 'Adres Ekle',
    exact: true,
    component: Address,
    options: { headerTitle: 'Adres Ekle' },
  },
  checkout: {
    key: 'checkout',
    path: routePaths.checkout,
    title: 'Güvenli Ödeme',
    component: Checkout,
    options: {
      headerTitle: 'Güvenli Ödeme',
      headerRight: createElement(SSLIcon),
    },
  },
  orders: {
    key: 'orders',
    path: routePaths.orders,
    title: 'Siparişlerim',
    component: Orders,
    isRootPage: false,
    exact: true,
    options: {
      headerTitle: 'Siparişlerim',
    },
  },
  orderContracts: {
    key: 'orderContracts',
    path: routePaths.orderContracts,
    title: 'Sözleşmeler',
    component: OrderContracts,
    exact: true,
    options: {
      headerTitle: 'Sözleşmeler',
    },
  },
  success: {
    key: 'success',
    path: '/success/:orderParentId',
    title: 'Sipariş Özeti',
    component: Success,
    isRootPage: true,
    exact: true,
    options: {
      headerTitle: 'Sipariş Özeti',
    },
  },
  notFound: {
    key: 'notFound',
    path: '*',
    title: 'Trendyol Dijital Servisler',
    exact: true,
    isRootPage: true,
    component: Landing,
    options: {
      headerTitle: 'Trendyol Dijital Servisler',
    },
  },
};
